import { useFormContext } from "react-hook-form";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc.js";
import timezone from "dayjs/plugin/timezone.js";
import customParseFormat from "dayjs/plugin/customParseFormat.js";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);
type Diffunit = 'd' | 'M' | 'y' | 'Q' | 'w';

const DelieryViewTime = () => {
  const methods = useFormContext();
  const { watch } = methods;

  // Watch all relevant fields at once
  const timeValue = watch("timeValue");
  const startDate = watch("startDate");
  const endDate = watch("endDate");
  const afterOccurrences = watch("quantityValue");
  const campaignType = watch("campaignType");

  const formatWithOrdinal = (d: any) => {
    try {
      return d.format("dddd, MMMM Do, YYYY [at] hh:mm A")
    }
    catch (error) {
      return d
    }
  };

  // condition: must have timeValue + startDate + (endDate OR afterOccurrences)
  const isReady = startDate;

  if (isReady) {
    let base;

    if (startDate && timeValue) {
      base = dayjs(`${startDate} ${timeValue}`, "YYYY-MM-DD HH:mm:ss");
    } else if (startDate) {
      const now = dayjs().add(5, 'minute');
      base = dayjs(`${startDate} ${now.format("HH:mm:ss")}`, "YYYY-MM-DD HH:mm:ss");
    } else {
      return null;
    }

    let unit: dayjs.ManipulateType = "day"; // default unit
    let interval = 1; // default interval
    let diffunit: Diffunit = 'd';
    if (campaignType === "Recurring Weekly") {
      unit = "week"; // add 1 week
      diffunit = 'w'
    } else if (campaignType === "Recurring Monthly") {
      unit = "month"; // add 1 month
      diffunit = 'M'
    } else if (campaignType === "Recurring Quarterly") {
      unit = "month"; // add 3 months
      diffunit = 'Q'
      interval = 3;
    } else if (campaignType === "Recurring Yearly") {
      unit = "year"; // add 1 year
      diffunit = 'y'
    }

    const firstDelivery = base;
    let lastDelivery;
    let secondDelivery: any = '-';

    if (endDate) {
      lastDelivery = dayjs(
        `${endDate} ${timeValue}`,
        "YYYY-MM-DD HH:mm:ss"
      );
      const unitdiff = dayjs(endDate).diff(dayjs(startDate), diffunit, true)
      if (unitdiff < 1) {
        secondDelivery = '-'
        lastDelivery = base
      }

      else if (unitdiff < 2) {
        const dt = base.add(1 * interval, unit)
        secondDelivery = dt
        lastDelivery = dt
      }

      else {
        secondDelivery = base.add(1 * interval, unit)
        lastDelivery = base.add(Math.floor(unitdiff) * interval, unit)
      }
    } else if (afterOccurrences) {
      //multiply occurrences with interval for correct last delivery
      if (afterOccurrences > 1) {
        secondDelivery = base.add(interval, unit);
        lastDelivery = base.add((afterOccurrences - 1) * interval, unit);
      }
      else {
        secondDelivery = '-'
        lastDelivery = base
      }

    }

    return (
      <div className="create-campaign__delivery-preview">
        <div className="create-campaign__delivery-preview__label">Delivery Preview</div>
        <div className="create-campaign__delivery-preview__status">
          First delivery: {formatWithOrdinal(firstDelivery)}
          <br />
          {campaignType !== "One-time" &&
            afterOccurrences !== "1" &&
            `Second delivery: ${formatWithOrdinal(secondDelivery)}`}
          {lastDelivery && <br />}
          {lastDelivery &&
            afterOccurrences !== "1" &&
            `Last delivery:  ${formatWithOrdinal(lastDelivery)}`}
        </div>
      </div>
    );
  }
  return null;
};

export default DelieryViewTime;
